import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-user\">\n  <path fill=\"currentColor\" d=\"M13.897 12.629c-1.564 0-2.727-.48-2.937-1.088 1.119-.45 1.878-1.787 1.878-4.327C12.838 5.196 11.811 4 10 4 8.187 4 7.162 5.196 7.162 7.215c0 2.54.757 3.877 1.877 4.327-.21.607-1.373 1.088-2.938 1.088C4.369 12.629 4 14.514 4 15.143c0 .473.384.857.857.857h10.286a.857.857 0 00.857-.857c0-.629-.372-2.514-2.103-2.514z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol